import { CloudOff, Loader2, RefreshCw, Trash2, UploadCloud } from "lucide-react";
import { useOutbox } from "../hooks/useOutbox";

/**
 * Connection + outbox status, shown at the top of every page only when there is
 * something to say: offline, submissions waiting to be sent, or ones the server
 * refused (with Retry / Discard).
 */
export function OutboxBanner() {
  const { online, pending, failed, syncing, retry, discard, syncNow } = useOutbox();
  if (online && pending.length === 0 && failed.length === 0) return null;

  return (
    <div className="no-print">
      {!online && (
        <div className="bg-amber-50 border-b border-amber-200 text-amber-900 text-sm px-4 py-2 flex items-center gap-2">
          <CloudOff className="w-4 h-4 flex-shrink-0" />
          <span>
            You are offline. Checklists you submit are saved on this device and sent automatically when the connection returns
            {pending.length > 0 && <> ({pending.length} waiting)</>}.
          </span>
        </div>
      )}
      {online && pending.length > 0 && (
        <div className="bg-sky-50 border-b border-sky-200 text-sky-900 text-sm px-4 py-2 flex items-center gap-2">
          {syncing ? <Loader2 className="w-4 h-4 animate-spin flex-shrink-0" /> : <UploadCloud className="w-4 h-4 flex-shrink-0" />}
          <span className="flex-1">
            {syncing ? "Sending" : "Waiting to send"} {pending.length} saved submission{pending.length > 1 ? "s" : ""}…
          </span>
          {!syncing && (
            <button type="button" onClick={syncNow} className="inline-flex items-center gap-1 font-medium hover:underline">
              <RefreshCw className="w-3.5 h-3.5" /> Send now
            </button>
          )}
        </div>
      )}
      {failed.map((f) => (
        <div key={f.id} className="bg-red-50 border-b border-red-200 text-red-800 text-sm px-4 py-2 flex flex-wrap items-center gap-2">
          <span className="flex-1 min-w-0">
            <b>{f.kind === "checklist" ? "Checklist" : "Bag checklist"}</b> {f.summary} could not be sent: {f.lastError ?? "unknown error"}
          </span>
          <button type="button" onClick={() => void retry(f.id)} className="inline-flex items-center gap-1 font-medium hover:underline">
            <RefreshCw className="w-3.5 h-3.5" /> Retry
          </button>
          <button
            type="button"
            onClick={() => {
              if (confirm("Discard this saved submission? It will be lost.")) void discard(f.id);
            }}
            className="inline-flex items-center gap-1 font-medium hover:underline"
          >
            <Trash2 className="w-3.5 h-3.5" /> Discard
          </button>
        </div>
      ))}
    </div>
  );
}
